import { getApiB2bApplicationByIdGet } from '/api/sdk.gen';

import type { AppDispatch } from '/business/shared/state/store';
import ValidationError from '/shared/errors/ValidationError';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';

const getApplication =
  (id: number | string | null = null) =>
  async (dispatch: AppDispatch) => {
    try {
      if (!id) {
        throw new Error('No data sent to get app');
      }
      dispatch({ type: 'APPLICATION_LOAD_START', applicationId: id, timestamp: Date.now() });
      const { data: application } = await getApiB2bApplicationByIdGet({
        path: { id: String(id) },
      });
      dispatch({ type: 'APPLICATION_LOAD_FULFILLED', application, applicationId: id });
      return application;
    } catch (error) {
      if (error instanceof ValidationError) {
        dispatch({ type: 'APPLICATION_LOAD_REJECTED', applicationId: id, error });
      } else {
        dispatch({
          type: 'APPLICATION_LOAD_REJECTED',
          applicationId: id,
          error: normaliseError(toNormaliseErrorInput(error), 'GET_FORM_STATE'),
        });
      }

      throw error;
    }
  };

export default getApplication;
